import {css} from '@mui/material';
import {DlMuiDynamicIcon} from '@wallaby-ui/core';
import React from 'react';

type Props = {
  /** A shared alert (filter owned by GLOBAL) shows a globe, a private one a person. */
  isGlobal: boolean;
  /** Icon font size in px; default 11 as in the row-bell tooltip. */
  fontSize?: number;
  /** When false the icon renders without its "Shared alert" / "Private alert" tooltip. */
  withTooltip?: boolean;
  style?: React.CSSProperties;
};

/**
 * The alert category icon shared by every alert surface (row-bell tooltip, Alerts panel, Alerts list,
 * Alert board): globe for a shared alert, person for a private alert. Colour is inherited.
 */
export const AlertCategoryIcon: React.FC<Props> = (props) => {
  const {isGlobal, fontSize = 11, withTooltip = true, style} = props;
  const iconCss = css`
    font-size: ${fontSize}px;
  `;
  return (
    <DlMuiDynamicIcon
      iconName={isGlobal ? 'globeIcon' : 'userIcon'}
      useFixedViewBox={isGlobal ? '0 0 512 512' : '0 0 12 12'}
      iconTitle={withTooltip ? (isGlobal ? 'alert.category.shared' : 'alert.category.private') : undefined}
      noButtonStyles
      style={{color: 'inherit', padding: 0, margin: 0, ...style}}
      svgIconInputCss={iconCss}
      data-name={'dl-alert-category-icon'}
      data-global={isGlobal}
    />
  );
};

AlertCategoryIcon.displayName = 'AlertCategoryIcon';
